<template>
  <form @submit.prevent="submit" class="form-wrapper with-loading" v-form:form novalidate>
    <div class="loading" v-if="isLoading">
      <Loader />
    </div>
    <div class="form-view">
      <h2 class="title">{{ $t('view.component.user.terms.formHeader') }}</h2>
      <div class="form-row">
        <div class="with-checkbox">
          <input type="checkbox"
                 required
                 v-model="formData.termsAgree"
                 id="terms"
                 name="terms" />
          <label for="terms" v-html="$t('view.component.user.register.labelTerms')"></label>
        </div>
        <p class="error-field"
           v-if="isErrorForField('terms')"
           v-html="getFieldErrorText('terms')">
        </p>
      </div>
      <div class="form-row">
        <p v-if="!showRodoTextLong" v-html="$t('view.component.user.register.rodoTextShort')"></p>
        <p v-if="showRodoTextLong" v-html="$t('view.component.user.register.rodoTextLong')"></p>
        <p v-if="!showRodoTextLong"><a href="" @click.prevent="showRodoTextLong = true" class="bold" v-html="$t('view.component.user.register.rodoShowMore')"></a></p>
        <p v-if="showRodoTextLong"><a href=""  @click.prevent="showRodoTextLong = false" class="bold" v-html="$t('view.component.user.register.rodoShowLess')"></a></p>
      </div>
      <div class="form-row submit-button-wrapper">
        <button type="submit" class="primary" :class="{disabled: !isFormValid()}">{{ $t('view.component.user.terms.buttonSubmit') }}</button>
      </div>
    </div>
  </form>
</template>

<script>
import Loader from '@/orange/components/Loader'
import FormMixin from '@/orange/mixins/form.mixin'
import { mapActions, mapGetters } from 'vuex'
import { ROUTING } from '@/orange/const/routing.const'
import { Notifier, NOTIFY_TYPE } from '@/common/class/notify.class'

export default {
  name: 'UserFormTerms',
  components: { Loader },
  mixins: [FormMixin],
  data () {
    return {
      showRodoTextLong: false,
      formData: {
        termsAgree: false
      }
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'isUserProcessing'
    })
  },
  methods: {
    ...mapActions([
      'setUserTermsAgree',
      'getUserSession'
    ]),
    submit () {
      if (this.form.invalid) {
        return
      }

      this.setUserTermsAgree()
        .then(() => {
          Notifier.show({
            text: this.$t('view.component.user.terms.processSuccess'),
            type: NOTIFY_TYPE.success
          })
          this.getUserSession().finally(() => {
            this.$router.push(ROUTING.topup.single.step1).catch(() => {})
          })
        })
        .catch(() => {
          Notifier.show({
            text: this.$t('view.component.user.terms.processError'),
            type: NOTIFY_TYPE.error
          })
        })
    }
  }
}
</script>

<style lang="scss" src="../../assets/scss/components/_login-register.scss" scoped></style>
